<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbPaymentsReceived',
  components: {},
}
</script>
